import httpClient from './httpClient';

export const ATTRIBUTE_SET_ENDPOINT = '/backoffice/attribute-sets';

export const getAttributeSetsAPI = async (params) => httpClient.get(`${ATTRIBUTE_SET_ENDPOINT}`, { params });
export const getAttributeSetAPI = (id) => httpClient.get(`${ATTRIBUTE_SET_ENDPOINT}/${id}`);
export const postAttributeSetAPI = async (name) => httpClient.post(`${ATTRIBUTE_SET_ENDPOINT}`, { name });
export const putAttributeSetAPI = (id, params) => httpClient.put(`${ATTRIBUTE_SET_ENDPOINT}/${id}`, params);
export const deleteAttributeSetAPI = (id) => httpClient.delete(`${ATTRIBUTE_SET_ENDPOINT}/${id}`);
